import {
  DashboardOutlined,
  UserOutlined,
  CarOutlined,
  FileProtectOutlined,
  EnvironmentOutlined,
  CustomerServiceOutlined,
  QuestionCircleOutlined,
  GiftOutlined,
  TeamOutlined,
  IdcardOutlined,
  BarChartOutlined,
  DollarOutlined,
  GlobalOutlined,
  SettingOutlined,
  BellOutlined,
  TrophyOutlined,
  ShareAltOutlined,
  BankOutlined,
  ScheduleOutlined,
  ShoppingOutlined,
  CloseCircleOutlined,
  RocketOutlined,
  FileTextOutlined,
  SwapOutlined,
  AlertOutlined,
  BulbOutlined,
  AimOutlined,
  AuditOutlined,
  WalletOutlined,
  PlayCircleOutlined,
  SafetyCertificateOutlined,
  TagOutlined,
  LinkOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';
import type { ResourceProps } from '@refinedev/core';
import { t } from '../i18n';

export const resources: ResourceProps[] = [
  // ============ TOP-LEVEL (no group) ============
  {
    name: 'dashboard',
    list: '/',
    meta: {
      label: t('nav.dashboard'),
      icon: <DashboardOutlined />,
      service: 'all',
    },
  },
  {
    name: 'admin/live-map',
    list: '/live-map',
    meta: {
      label: t('nav.liveMap'),
      icon: <GlobalOutlined />,
      service: 'taxi',
      permission: { group: 'trips', action: 'read' },
    },
  },

  // ============ ASOSIY (Main) ============
  {
    name: 'group-asosiy',
    meta: {
      label: t('nav.main'),
      isGroup: true,
      service: 'taxi',
    },
  },
  // -- Foydalanuvchilar submenu --
  {
    name: 'users',
    meta: {
      label: t('nav.users'),
      icon: <UserOutlined />,
      parent: 'group-asosiy',
      service: 'taxi',
    },
  },
  {
    name: 'admin/users',
    list: '/users',
    show: '/users/:id',
    meta: {
      label: t('nav.allUsers'),
      icon: <UserOutlined />,
      parent: 'users',
      service: 'taxi',
      permission: { group: 'users', action: 'read' },
    },
  },
  {
    name: 'admin/passengers',
    list: '/passengers',
    show: '/passengers/:id',
    meta: {
      label: t('nav.passengers'),
      icon: <IdcardOutlined />,
      parent: 'users',
      service: 'taxi',
      permission: { group: 'users', action: 'read' },
    },
  },
  {
    name: 'admin/drivers',
    list: '/drivers',
    create: '/drivers/create',
    show: '/drivers/:id',
    meta: {
      label: t('nav.drivers'),
      icon: <CarOutlined />,
      parent: 'users',
      service: 'taxi',
      permission: { group: 'drivers', action: 'read' },
    },
  },
  // -- Самозанятость проверка (Soliq.uz) --
  {
    name: 'admin/self-employment-check',
    list: '/self-employment-check',
    meta: {
      label: 'Самозанятость',
      icon: <SafetyCertificateOutlined />,
      parent: 'users',
      service: 'taxi',
      permission: { group: 'drivers', action: 'read' },
    },
  },
  // -- Hujjatlar --
  {
    name: 'admin/documents',
    list: '/documents',
    meta: {
      label: t('nav.documents'),
      icon: <FileProtectOutlined />,
      parent: 'group-asosiy',
      service: 'taxi',
      permission: { group: 'documents', action: 'read' },
    },
  },
  // -- Sug'urta --
  {
    name: 'admin/insurance',
    list: '/insurance',
    meta: {
      label: t('nav.insurance'),
      icon: <SafetyCertificateOutlined />,
      parent: 'group-asosiy',
      service: 'taxi',
      permission: { group: 'drivers', action: 'read' },
    },
  },
  // -- Sayohatlar submenu --
  {
    name: 'trips-group',
    meta: {
      label: t('nav.trips'),
      icon: <EnvironmentOutlined />,
      parent: 'group-asosiy',
      service: 'taxi',
    },
  },
  {
    name: 'admin/trips',
    list: '/trips',
    create: '/trips/create',
    show: '/trips/:tripType/:id',
    edit: '/trips/:tripType/:id/edit',
    meta: {
      label: t('nav.allTrips'),
      icon: <EnvironmentOutlined />,
      parent: 'trips-group',
      service: 'taxi',
      permission: { group: 'trips', action: 'read' },
    },
  },
  {
    name: 'admin/driver-posted-trips',
    list: '/driver-posted-trips',
    show: '/driver-posted-trips/:id',
    meta: {
      label: t('nav.driverTrips'),
      icon: <SwapOutlined />,
      parent: 'trips-group',
      service: 'taxi',
      permission: { group: 'trips', action: 'read' },
    },
  },
  {
    name: 'admin/yol-yolakay-offers',
    list: '/yol-yolakay-offers',
    meta: {
      label: t('nav.yolYolakayOffers'),
      icon: <AimOutlined />,
      parent: 'trips-group',
      service: 'taxi',
      permission: { group: 'trips', action: 'read' },
    },
  },
  // /driver-trip-bookings hidden from nav per ops request — route still
  // mounted in App.tsx so existing deep links don't 404.

  // ============ MOLIYA (Finance) ============
  {
    name: 'group-moliya',
    meta: {
      label: t('nav.finance'),
      isGroup: true,
      service: 'taxi',
    },
  },
  {
    name: 'taxi/payments',
    list: '/payments',
    meta: {
      label: t('nav.payments'),
      icon: <DollarOutlined />,
      parent: 'group-moliya',
      service: 'taxi',
      permission: { group: 'payments', action: 'read' },
    },
  },
  {
    name: 'admin/pricing',
    list: '/pricing',
    meta: {
      label: t('nav.pricing'),
      icon: <SettingOutlined />,
      parent: 'group-moliya',
      service: 'taxi',
      permission: { group: 'payments', action: 'read' },
    },
  },
  {
    name: 'admin/tariffs',
    list: '/tariffs',
    meta: {
      label: t('nav.tariffs'),
      icon: <TagOutlined />,
      parent: 'group-moliya',
      service: 'taxi',
      permission: { group: 'settings', action: 'read' },
    },
  },
  {
    name: 'taxi/promo-codes',
    list: '/promo-codes',
    create: '/promo-codes/create',
    meta: {
      label: t('nav.promoCodes'),
      icon: <GiftOutlined />,
      parent: 'group-moliya',
      service: 'taxi',
      permission: { group: 'promo', action: 'read' },
    },
  },
  {
    name: 'admin/tracking-links',
    list: '/tracking-links',
    create: '/tracking-links/create',
    show: '/tracking-links/:id',
    meta: {
      label: t('nav.trackingLinks'),
      icon: <LinkOutlined />,
      parent: 'group-moliya',
      service: 'taxi',
      permission: { group: 'tracking-links', action: 'read' },
    },
  },
  {
    name: 'admin/incentives',
    list: '/incentives',
    meta: {
      label: t('nav.incentives'),
      icon: <TrophyOutlined />,
      parent: 'group-moliya',
      service: 'taxi',
      permission: { group: 'payments', action: 'read' },
    },
  },
  {
    name: 'admin/referrals',
    list: '/referrals',
    meta: {
      label: t('nav.referrals'),
      icon: <ShareAltOutlined />,
      parent: 'group-moliya',
      service: 'taxi',
      permission: { group: 'payments', action: 'read' },
    },
  },

  // ============ QOLLAB-QUVVATLASH (Support) ============
  {
    name: 'group-support',
    meta: {
      label: t('nav.support'),
      isGroup: true,
      service: 'taxi',
    },
  },
  {
    name: 'admin/tickets',
    list: '/emergency',
    show: '/emergency/:id',
    identifier: 'emergency',
    meta: {
      label: t('nav.emergency'),
      icon: <AlertOutlined />,
      parent: 'group-support',
      service: 'taxi',
      permission: { group: 'support', action: 'read' },
    },
  },
  {
    name: 'admin/tickets',
    list: '/suggestions',
    show: '/suggestions/:id',
    identifier: 'suggestions',
    meta: {
      label: t('nav.suggestions'),
      icon: <BulbOutlined />,
      parent: 'group-support',
      service: 'taxi',
      permission: { group: 'support', action: 'read' },
    },
  },
  // /chat (Chat ko'ruvchi) hidden from nav per ops request — route still
  // mounted in App.tsx so existing deep links don't 404.
  {
    name: 'taxi/faqs',
    list: '/faq',
    create: '/faq/create',
    edit: '/faq/:id/edit',
    meta: {
      label: t('nav.faq'),
      icon: <QuestionCircleOutlined />,
      parent: 'group-support',
      service: 'taxi',
      permission: { group: 'faq', action: 'read' },
    },
  },

  // ============ SOZLAMALAR (Config) ============
  {
    name: 'group-config',
    meta: {
      label: t('nav.config'),
      isGroup: true,
      service: 'taxi',
    },
  },
  {
    name: 'admin/locations',
    list: '/locations',
    meta: {
      label: t('nav.locations'),
      icon: <EnvironmentOutlined />,
      parent: 'group-config',
      service: 'taxi',
      permission: { group: 'settings', action: 'read' },
    },
  },
  {
    name: 'admin/tutorials',
    list: '/tutorials',
    meta: {
      label: t('nav.tutorials'),
      icon: <PlayCircleOutlined />,
      parent: 'group-config',
      service: 'taxi',
      permission: { group: 'settings', action: 'read' },
    },
  },
  {
    name: 'admin/car-brands',
    list: '/car-brands',
    meta: {
      label: t('nav.carBrands'),
      icon: <CarOutlined />,
      parent: 'group-config',
      service: 'taxi',
      permission: { group: 'settings', action: 'read' },
    },
  },
  {
    name: 'admin/cancellation-reasons',
    list: '/cancellation-reasons',
    create: '/cancellation-reasons/create',
    edit: '/cancellation-reasons/:id/edit',
    meta: {
      label: t('nav.cancellationReasons'),
      icon: <CloseCircleOutlined />,
      parent: 'group-config',
      service: 'taxi',
      permission: { group: 'settings', action: 'read' },
    },
  },
  {
    name: 'admin/faollik-bali',
    list: '/faollik-bali',
    meta: {
      label: t('nav.faollikBali'),
      icon: <ThunderboltOutlined />,
      parent: 'group-config',
      service: 'taxi',
      permission: { group: 'settings', action: 'read' },
    },
  },
  {
    name: 'admin/app-updates',
    list: '/app-updates',
    create: '/app-updates/create',
    edit: '/app-updates/:id/edit',
    meta: {
      label: t('nav.appUpdates'),
      icon: <RocketOutlined />,
      parent: 'group-config',
      service: 'taxi',
      permission: { group: 'settings', action: 'read' },
    },
  },
  {
    name: 'taxi/notifications',
    list: '/notifications',
    meta: {
      label: t('nav.notifications'),
      icon: <BellOutlined />,
      parent: 'group-config',
      service: 'taxi',
      permission: { group: 'settings', action: 'read' },
    },
  },
  {
    name: 'admin/staff',
    list: '/staff',
    create: '/staff/create',
    show: '/staff/:id',
    edit: '/staff/:id/edit',
    meta: {
      label: t('nav.staff'),
      icon: <TeamOutlined />,
      parent: 'group-config',
      service: 'taxi',
      permission: { group: 'staff', action: 'read' },
    },
  },
  {
    name: 'admin/audit-logs',
    list: '/audit-logs',
    meta: {
      label: t('nav.auditLog'),
      icon: <AuditOutlined />,
      parent: 'group-config',
      service: 'taxi',
      permission: { group: 'staff', action: 'read' },
    },
  },
  {
    name: 'admin/withdrawals',
    list: '/withdrawals',
    meta: {
      label: t('nav.withdrawals'),
      icon: <WalletOutlined />,
      parent: 'group-config',
      service: 'taxi',
      permission: { group: 'payments', action: 'read' },
    },
  },
  {
    name: 'taxi/settings',
    list: '/settings',
    meta: {
      label: t('nav.settings'),
      icon: <SettingOutlined />,
      parent: 'group-config',
      service: 'taxi',
      permission: { group: 'settings', action: 'read' },
    },
  },

  // ============ ANALITIKA ============
  {
    name: 'group-analytics',
    meta: {
      label: t('nav.analytics'),
      isGroup: true,
      service: 'taxi',
    },
  },
  {
    name: 'taxi/analytics',
    list: '/analytics',
    meta: {
      label: t('nav.analyticsPage'),
      icon: <BarChartOutlined />,
      parent: 'group-analytics',
      service: 'taxi',
      permission: { group: 'trips', action: 'read' },
    },
  },
  {
    name: 'taxi/reports',
    list: '/reports',
    meta: {
      label: t('nav.reports'),
      icon: <FileTextOutlined />,
      parent: 'group-analytics',
      service: 'taxi',
      permission: { group: 'trips', action: 'read' },
    },
  },

  // ============ BUS SERVICE RESOURCES ============
  {
    name: 'group-bus-main',
    meta: {
      label: t('nav.main'),
      isGroup: true,
      service: 'bus',
    },
  },
  {
    name: 'admin/bus/companies',
    list: '/bus/companies',
    create: '/bus/companies/create',
    show: '/bus/companies/:id',
    meta: {
      label: t('nav.busCompanies'),
      icon: <BankOutlined />,
      parent: 'group-bus-main',
      service: 'bus',
      hideForBusCompany: true,
    },
  },
  {
    name: 'bus/company/me',
    list: '/bus/company/me',
    meta: {
      label: t('nav.busCompanyProfile'),
      icon: <BankOutlined />,
      parent: 'group-bus-main',
      service: 'bus',
      busCompanyOnly: true,
    },
  },
  {
    name: 'admin/bus/trips',
    list: '/bus/trips',
    create: '/bus/trips/create',
    show: '/bus/trips/:id',
    edit: '/bus/trips/:id/edit',
    meta: {
      label: t('nav.busTrips'),
      icon: <ScheduleOutlined />,
      parent: 'group-bus-main',
      service: 'bus',
    },
  },
  {
    name: 'admin/bus/bookings',
    list: '/bus/bookings',
    create: '/bus/bookings/create',
    show: '/bus/bookings/:id',
    meta: {
      label: t('nav.bookings'),
      icon: <ShoppingOutlined />,
      parent: 'group-bus-main',
      service: 'bus',
    },
  },

  // Bus finance
  {
    name: 'group-bus-moliya',
    meta: {
      label: t('nav.finance'),
      isGroup: true,
      service: 'bus',
    },
  },
  {
    name: 'bus/payments',
    list: '/bus/payments',
    meta: {
      label: t('nav.payments'),
      icon: <DollarOutlined />,
      parent: 'group-bus-moliya',
      service: 'bus',
    },
  },
  {
    name: 'bus/promo-codes',
    list: '/bus/promo-codes',
    create: '/bus/promo-codes/create',
    meta: {
      label: t('nav.promoCodes'),
      icon: <GiftOutlined />,
      parent: 'group-bus-moliya',
      service: 'bus',
      hideForBusCompany: true,
    },
  },
  {
    name: 'bus/reports',
    list: '/bus/reports',
    meta: {
      label: t('nav.reports'),
      icon: <FileTextOutlined />,
      parent: 'group-bus-moliya',
      service: 'bus',
      busCompanyOnly: true,
    },
  },

  // Bus support
  {
    name: 'group-bus-support',
    meta: {
      label: t('nav.support'),
      isGroup: true,
      service: 'bus',
    },
  },
  {
    name: 'bus/tickets',
    list: '/bus/support',
    show: '/bus/support/:id',
    meta: {
      label: t('nav.supportTickets'),
      icon: <CustomerServiceOutlined />,
      parent: 'group-bus-support',
      service: 'bus',
      hideForBusCompany: true,
    },
  },
  {
    name: 'bus/faqs',
    list: '/bus/faq',
    create: '/bus/faq/create',
    edit: '/bus/faq/:id/edit',
    meta: {
      label: t('nav.faq'),
      icon: <QuestionCircleOutlined />,
      parent: 'group-bus-support',
      service: 'bus',
      hideForBusCompany: true,
    },
  },

  // Bus config
  {
    name: 'group-bus-config',
    meta: {
      label: t('nav.config'),
      isGroup: true,
      service: 'bus',
    },
  },
  {
    name: 'bus/notifications',
    list: '/bus/notifications',
    meta: {
      label: t('nav.notifications'),
      icon: <BellOutlined />,
      parent: 'group-bus-config',
      service: 'bus',
      hideForBusCompany: true,
    },
  },
  {
    name: 'bus/staff',
    list: '/bus/staff',
    create: '/bus/staff/create',
    show: '/bus/staff/:id',
    edit: '/bus/staff/:id/edit',
    meta: {
      label: t('nav.staff'),
      icon: <TeamOutlined />,
      parent: 'group-bus-config',
      service: 'bus',
      hideForBusCompany: true,
    },
  },
  {
    name: 'bus/settings',
    list: '/bus/settings',
    meta: {
      label: t('nav.settings'),
      icon: <SettingOutlined />,
      parent: 'group-bus-config',
      service: 'bus',
      hideForBusCompany: true,
    },
  },

  // Bus analytics
  {
    name: 'group-bus-analytics',
    meta: {
      label: t('nav.analytics'),
      isGroup: true,
      service: 'bus',
    },
  },
  {
    name: 'bus/analytics',
    list: '/bus/analytics',
    meta: {
      label: t('nav.analyticsPage'),
      icon: <BarChartOutlined />,
      parent: 'group-bus-analytics',
      service: 'bus',
    },
  },
];
